import React from 'react';
import Swiper from 'react-id-swiper';
import {
    TOP_LOGOS,
    BOTTOM_LOGOS,
    SETTINGS
} from './constants';

import * as styles from './LandingLogosCarousel.scss';

const LogosCarousel = () => (
    <div className={styles.containerSlider}>
        <Swiper {...SETTINGS}>
            {TOP_LOGOS.map((item) => (
                <div>
                    <div className={styles.logoWrapper}>
                        <img src={item} alt="realtor" />
                    </div>
                </div>
            ))}
        </Swiper>
        <div className={styles.line} />
        <Swiper {...SETTINGS}>
            {BOTTOM_LOGOS.map((item) => (
                <div>
                    <div className={styles.logoWrapper}>
                        <img src={item} alt="realtor" />
                    </div>
                </div>
            ))}
        </Swiper>
    </div>
);

export default LogosCarousel;
